import React from 'react'
import {useClearRefinements} from 'react-instantsearch-hooks-web'
import {Text, BaseButton} from '../../../../../vanilla'
import {SliderIcon} from '../../../../icons/SliderIcon'

interface RefinementsMenuTogglerProps {
  onClick: () => void
}

export const RefinementsMenuToggler = (props: RefinementsMenuTogglerProps) => {
  const {onClick} = props

  const {canRefine} = useClearRefinements()

  return (
    <BaseButton
      width="full"
      paddingX="12px"
      onClick={onClick}
      variant="unstyled"
      border="1px"
      borderColor={canRefine ? 'accent3' : 'gray200'}
      height="36px"
      background="white"
      justifyContent="space-between"
      color={canRefine ? 'accent3' : undefined}
    >
      <Text variant="text3">Filters</Text>
      <SliderIcon boxSize="16px" color={canRefine ? 'accent3' : 'gray800'} />
    </BaseButton>
  )
}
